const Graph = require('./BaseGraph')

module.exports = class CourseGraph extends Graph 
{
    constructor(apiDomain, path="course")
    {
        super(apiDomain, path)
    }

    coursesQuery(fields, params=null)
    {
        if (params)
            return { type: 'courses', query: this.queryString('courses', fields, params) }

        return { type: 'courses', query: `query courses ($is_active: Int!) {
            courses(is_active: $is_active)
            ${this.queryFields(fields)}
        }` }
    }

    courseQuery(fields, params=null)
    {
        if (params)
            return { type: 'course', query: this.queryString('course', fields, params) }

        return { type: 'course', query: `query course ($slug: String!) {
            course(slug: $slug)
            ${this.queryFields(fields)}
        }` }
    }


    lessonsQuery(fields, params=null)
    {
        if (params)
            return { type: 'lessons', query: this.queryString('lessons', fields, params) }

        return { type: 'lessons', query: `query getLessons($course_id: Int!) {
            lessons(course_id: $course_id)
            ${this.queryFields(fields)}
        }` }
    }

    resourcesQuery(fields, params=null)
    {
        if (params)
            return { type: 'resources', query: this.queryString('resources', fields, params) }

        return { type: 'resources', query: `query getResources($course_id: Int!) {
            resources(course_id: $course_id)
            ${this.queryFields(fields)}
        }` }
    }

    discountsQuery(fields, params=null)
    {
        if (params)
            return { type: 'discounts', query: this.queryString('discounts', fields, params) }

        return { type: 'discounts', query: `query getDiscounts($course_id: Int!) {
            discounts(course_id: $course_id)
            ${this.queryFields(fields)}
        }` }
    }

    sessionQuery(fields, params=null)
    {
        if (params)
            return { type: 'session', query: this.queryString('session', fields, params) }

        return { type: 'session', query: `query getSession($session: Int!) {
            session(session: $session)
            ${this.queryFields(fields)}
        }` }
    }

}